import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import useNavTabBar from './hooks/useNavTabBar';
import useTooltip from '../tooltip/hooks/useTooltip';

import ChevronLeft from '../svg/ChevronLeft';

function ActionPrev(props) {
  useTooltip(`ref-prev`, `Go Back`, `Go Back`);
  const { active, onClick } = useNavTabBar('previous');

  return (
    <div id={`ref-prev`} onClick={ active ? onClick : null } className={`arrow-link chevron-left ${active && `active`}`} style={{ cursor: active ? `pointer` : `default` }}>
      <ChevronLeft color={ active ? Config.TYPE_LIGHT : Config.TYPE_PLACEHOLDER } />
    </div>
  )
}

ActionPrev.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func
}

export default ActionPrev;
